import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'environments/environment';

import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';

@Injectable()
export class ConfigsService {

  private _configsObs: ReplaySubject<any>;

  constructor(
    private http: HttpClient
  ) {}

  public getConfigs(force?: boolean): Observable<any> {
    if (this._configsObs && !force){
      return this._configsObs;
    }
    else {
      return this.refreshConfigs();
    }
  }

  public refreshConfigs(): Observable<any> {
    if (!this._configsObs) {
      this._configsObs = new ReplaySubject<any>(1);
    }
    return this.http.get(`${environment.API_URL}/ws/app/configs`)
      .map((configsData) => {
        if (!configsData) configsData = null;
        this._configsObs.next(configsData);
      })
      .mergeMap(() => this._configsObs);
  }
}



// WEBPACK FOOTER //
// ./src/app/configs/configs.service.ts